export const convertDateToUTC = (date: Date, formatter: (date: Date) => string) => {
  return new Date(formatter(date))
}
